module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-STEAM.1324cedb.png";